import React from "react";

import { Text, View } from "react-native";

export const KDStores = ({ navigation }) => {
  return <View><Text>Reportings</Text></View>;
};
